import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex } from 'components/Flex';
import { useId } from 'react';
import { Tooltip } from 'react-tooltip';
import styled from 'styled-components';
import { theme } from 'styles';

const StyledButton = styled.button<{ $disabled?: boolean }>`
  background: transparent;
  border: none;
  padding: 0;
  ${({ $disabled }) => ($disabled ? 'cursor: not-allowed; opacity: 0.55;' : 'cursor: pointer;')}
`;

interface Props {
  onClick?: () => void;
  locked?: boolean;
  active?: boolean;
  disabled?: boolean;
  title?: string;
  tooltipId?: string;
}

export const PadlockButton: React.FC<Props> = ({
  onClick,
  locked,
  active = true,
  disabled,
  title,
  tooltipId
}) => {
  const generatedId = useId().replace(/:/g, '');
  const anchorId = tooltipId || `padlock-${generatedId}`;

  const handleClick = () => {
    if (disabled) return;
    onClick?.();
  };

  return (
    <>
      <StyledButton
        id={anchorId}
        type="button"
        aria-disabled={disabled}
        $disabled={disabled}
        onClick={handleClick}
        data-tooltip-content={title}
      >
        <Flex flexDirection="row" justifyContent="center">
          {locked ? (
            <FontAwesomeIcon
              icon={faLock}
              size="2x"
              color={
                active
                  ? theme.palette.accent.orange
                  : theme.palette.neutral.greyButton
              }
            />
          ) : (
            <FontAwesomeIcon
              icon={faLockOpen}
              size="2x"
              color={
                active
                  ? theme.palette.accent.green
                  : theme.palette.neutral.greyButton
              }
            />
          )}
        </Flex>
      </StyledButton>
      {title && (
        <Tooltip anchorId={anchorId} style={{ zIndex: 10002 }} delayShow={200} />
      )}
    </>
  );
};
